import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * ScrollToTop Component
 * Automatically scrolls to top when route changes
 * Ensures better UX by starting each page from the top
 */
const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    // Scroll to top instantly when route changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Changed from 'smooth' for instant scroll
    })
  }, [pathname])

  return null
}

export default ScrollToTop

